import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ontos-accent", [_ctx.accentClass(_ctx.color), (_ctx.vertical || _ctx.row) ? 'ontos-accent--vertical' : '', _ctx.row ? 'ontos-accent--row' : '']])
  }, null, 2))
}